// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6489) return "static/chunks/6489-ffb090191437590c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3844":"3133b0f9bb7385de","4024":"03a9b3f1af950d33"}[chunkId] + ".js";
};